export const selectAllField = (state) => state.selectAllField
export const funders = (state) => state.funders
export const selectedFunders = (state) => state.selectedFunders
export const totalFunders = (state) => state.totalFunders
export const viewFunder = (state) => state.viewFunder